import {Component, Input, OnInit, Inject, OnChanges, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import { ProjectService } from '../project.service';
import { Respondent } from '../../model/respondent';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import {Questionnaire} from '../../model/questionnaire';
import {DOCUMENT} from '@angular/common';
import {ValidationService} from '../../service/validation-service';


@Component({
    moduleId: module.id,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'questionnaire-form',
    template: `
	<form [formGroup]="myForm" novalidate>
	<div *ngFor="let question of this.questionnaire.questions" class="form-group">
		 <div *ngIf="question.toSave">
				<label>{{question.no}}) {{question.texts.get(respondent.Language)}}</label>
				<div [ngSwitch]="question.type">
					<ng-container *ngSwitchCase="'combo'">
					<!--<select formControlName="{{question.no}}" class="form-control languageDropdown" (ngModelChange)="updateAnswer(question.no,$event)">
						<option *ngFor="let choice of question.choices[0].texts.get(respondent.Language)" [value]="choice" [selected]="choice === respondent.getResponse(question.no).answer">{{choice}}</option>
					</select>-->
                        <div class="btn-group">
                            <button type="button" class="btn btn-primary">{{respondent.getResponse(question.no).answer}}</button>
                            <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                            </button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" *ngFor="let choice of question.choices" (click)="updateAnswer(question.no,$event.srcElement)">{{choice.texts.get(respondent.Language)}}</a>
                            </div>
                        </div>
					</ng-container>
					<ng-container *ngSwitchCase="'radio'">
						<div *ngFor="let choice of question.choices" class="radio">
							<label>
							<input type="radio" formControlName = "{{question.no}}"  [checked]="validateBoolean(this.getRespondentAnswer(question.no))" [value]="this.getRespondentAnswer(question.no)" (ngModelChange)="updateAnswer(question.no,$event)">
								{{choice.texts[respondent.Language]}}
						</label>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'check'">
						<div *ngFor="let choice of question.choices" class="check">
							<label>
							<input type="checkbox" formControlName="{{question.no}}" [checked]="validateBoolean(this.getRespondentAnswer(question.no))"  [value]="this.getRespondentAnswer(question.no)" (ngModelChange)="updateAnswer(question.no,$event)">
								{{choice.texts[respondent.Language]}}
							</label>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="'picture'">
						<input  formControlName="{{question.no}}" type="text" class="form-control"  readonly  [value]="this.getRespondentAnswer(question.no)" (ngModelChange)="updateAnswer(question.no,$event)"  [(ngModel)]="respondent.getResponse(question.no).answer" />
                        <br>
                        <div class="card" style="width: 18rem;">
                          <img class="card-img-top" [src]="getImgLink(respondent.getResponse(question.no).answer) | secure |async" alt="Card image cap">
                        </div>
                    </ng-container>

                  <ng-container *ngSwitchCase="'vimeo'">
                    <input  formControlName="{{question.no}}" type="text" class="form-control"  readonly /> <!--question.choices[0].answer-->
                    <br/>
                    <div class="embed-responsive embed-responsive-4by3">
                      <iframe class="embed-responsive-item" src="https://player.vimeo.com/video/{{respondent.getResponse(question.no)}}"></iframe>
                    </div>
                  </ng-container>

					<ng-container *ngSwitchCase="'photo_bundle'">
						<input  formControlName="{{question.no}}" type="text" class="form-control"  readonly  [value]="this.getRespondentAnswer(question.no)" (change)="updateAnswer(question.no,$event)" />
					</ng-container>

					<ng-container *ngSwitchDefault>
						<ng-container *ngIf="question.validator == null || question.validator == ''" >
							<input formControlName="{{question.no}}" [value]="this.getRespondentAnswer(question.no)" (change)="updateAnswer(question.no,$event)"/>
					    </ng-container>
						<ng-container *ngIf="question.validator != null">
							<ng-container [ngSwitch]="question.validator">
								<ng-container *ngSwitchCase="'alpha'">
								<input  formControlName="{{question.no}}" type="text" class="form-control" [value]="this.getRespondentAnswer(question.no)" (change)="updateAnswer(question.no,$event)" />
								<control-message [control]="myForm.controls[question.no]"></control-message>
								</ng-container>
								<ng-container *ngSwitchCase="'email'">
									<input formControlName="{{question.no}}" type="text" class="form-control" [value]="this.getRespondentAnswer(question.no)" (change)="updateAnswer(question.no,$event)"/>
									<control-message [control]="myForm.controls[question.no]"></control-message>
								</ng-container>
								<ng-container *ngSwitchCase="'phone'">
									<input formControlName="{{question.no}}" type="text" class="form-control" [value]="this.getRespondentAnswer(question.no)" (change)="updateAnswer(question.no,$event)"  />
									<control-message [control]="myForm.controls[question.no]"></control-message>
								</ng-container>
								<ng-container *ngSwitchCase="'numeric'">
									<input formControlName="{{question.no}}" type="text" class="form-control" [value]="this.getRespondentAnswer(question.no)" (change)="updateAnswer(question.no,$event)"/>
								</ng-container>
								<ng-container *ngSwitchCase="'canadaCode'">
									<input formControlName="{{question.no}}" type="text" class="form-control" [value]="this.getRespondentAnswer(question.no)"  (change)="updateAnswer(question.no,$event)"/>
								</ng-container>
								<ng-container *ngSwitchCase="'usaCode'">
									<input formControlName="{{question.no}}" type="text" class="form-control" [value]="this.getRespondentAnswer(question.no)" (change)="updateAnswer(question.no,$event)"/>
								</ng-container>
							</ng-container>
						</ng-container>
					</ng-container>
				</div>
		 </div>
	</div>
</form>

<ng-template #loading>
   Loading Respondent ...
</ng-template>
	`,
  styles:[`
    .languageDropdown{width: auto;}
  `]
})
export class QuestionnaireComponent implements OnInit, OnChanges {

    @Input() respondent: Respondent;
    @Input() questionnaire: Questionnaire;

    public myForm= new FormGroup({});

    constructor(private _projectService: ProjectService, private formBuilder: FormBuilder,@Inject(DOCUMENT) private document: Document) {
      console.log('constructing questionnaire component');
    }

    ngOnInit() {
      console.log('initializing questionnaire component');
      console.log(this.respondent);
      console.log(this.questionnaire);
      this.toGroup();
    }

    toGroup():boolean {
        const group: any = [];
        for (const question of this.questionnaire.questions) {
            if (question.validator != null) {
                const validtxt = question.validator;
                switch (validtxt) {
                    case 'alpha':
                        group[question.no] = new FormControl('', Validators.required);
                        break;
                    case 'email':
                        group[question.no] = new FormControl('', [Validators.required, ValidationService.emailValidator]);
                        break;
                    case 'phone':
                        group[question.no] = new FormControl('', [Validators.required, ValidationService.phoneValidator]);
                        break;
                    case 'numeric':
                        group[question.no] = new FormControl('');
                        break;
                    case 'canadaCode':
                        group[question.no] = new FormControl('');
                        break;
                    case 'usaCode':
                        group[question.no] = new FormControl('');
                        break;
                    default: group[question.no] = new FormControl('');
                }
            } else {
                group[question.no] = new FormControl('');
                console.log('loaded question no:' + question.no);
            }

        }
       this.myForm = this.formBuilder.group(group);

        return true;
    }

    private getImgLink(answer:string):string {
        console.log(answer);
        if(answer.includes('jpg') || answer.includes('png')) {
            return 'http://'+this.document.location.hostname+':'+this.document.location.port+'/'+answer;
        }

        return 'http://'+this.document.location.hostname+':'+this.document.location.port+'/'+'emailTemplates/samplePlaceholder.jpg';
    }

    private getRespondentAnswer(qNo:number):string {
      if(this.respondent.getResponse(qNo)!=null) {
           console.log(qNo);
           console.log(this.respondent.getResponse(qNo).answer);
          return this.respondent.getResponse(qNo).answer;
      }
      return '';
    }

    ngOnChanges(changes: SimpleChanges): void {

        console.log('Async triggered change checked');
    }

    updateAnswer(no: number,updatedVal:any) {
        if(updatedVal.target == null) {
            this.respondent.setResponse(no,updatedVal);
        } else if(updatedVal.target === '' && updatedVal.tagName.toLowerCase() === 'a') {
            this.respondent.setResponse(no, updatedVal.text);
        } else {
            this.respondent.setResponse(no, updatedVal.target.value);
        }
    }

    validateBoolean(value: string):boolean {
        if(value === '1'|| value === 'true' || value ==='yes') {
            return true;
        }
        return false;
    }
}

